export const extractFromAddress = (components, type, keyType) => {
  return (
    components
      .filter((component) => component.types.indexOf(type) === 0)
      .map((item) => item[keyType] || item.name || item.shortName) // Preference to long_name over short_name unless specified by keyType - for example in case of country or state.
      .pop() || null
  );
};
